<div class="relative" [class.has-background]="theme() === CarouselTheme.HAS_BACKGROUND">
  @if (prevButtonVisible()) {
    <div
      class="button-prev z1 flex flex--start flex--center grow"
      [class.container-shadow]="hasContainerShadow()"
      [class.grey]="hasGreyBackground()"
    >
      @if (hasContainerShadow()) {
        <button type="button" class="scroll-hit-area" aria-hidden="true" tabindex="-1" (click)="scrollPrev()"></button>
      }
      <fcom-icon-button
        [aria]="{
          hidden: !prevButtonAriaLabel(),
          label: prevButtonAriaLabel(),
        }"
        [icon]="{
          category: IconLibrary.SVG_LIBRARY,
          name: leftIcon(),
        }"
        [theme]="hasContainerShadow() ? IconButtonTheme.TERTIARY_GHOST : IconButtonTheme.SECONDARY_OUTLINE"
        [size]="iconButtonSize()"
        (clickBtn)="scrollPrev()"
      >
      </fcom-icon-button>
    </div>
  }
  @if (nextButtonVisible()) {
    <div
      class="button-next z1 flex flex--end flex--center grow"
      [class.container-shadow]="hasContainerShadow()"
      [class.grey]="hasGreyBackground()"
    >
      @if (hasContainerShadow()) {
        <button type="button" class="scroll-hit-area" aria-hidden="true" tabindex="-1" (click)="scrollNext()"></button>
      }
      <fcom-icon-button
        [aria]="{
          hidden: !nextButtonAriaLabel(),
          label: nextButtonAriaLabel(),
        }"
        [icon]="{
          category: IconLibrary.SVG_LIBRARY,
          name: rightIcon(),
        }"
        [theme]="hasContainerShadow() ? IconButtonTheme.TERTIARY_GHOST : IconButtonTheme.SECONDARY_OUTLINE"
        [size]="iconButtonSize()"
        (clickBtn)="scrollNext()"
      >
      </fcom-icon-button>
    </div>
  }
  <div
    #contentWrap
    class="content-wrap flex"
    [ngClass]="{
      'flex--center': align() === 'center' && !(prevButtonVisible() || nextButtonVisible()),
      'flex--end': align() === 'right',
    }"
    (scroll)="onScroll()"
  >
    <div #content class="content" (cdkObserveContent)="onContentChange()"><ng-content /></div>
  </div>
</div>
